


































































































































import Vue from 'vue';
import moment from 'moment';
import { mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import { CarrierContract } from '@/models/carriers/CarrierContract';

import carrierService from '@/services/CarrierService';
import localStorageService from '@/services/LocalStorageService';
import miscService from '@/services/MiscService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      currentPage: 1,
      loading: false,
      displayReadonlyDisclaimer: true,
      term: '',
      currentTab: 'Active',
      showSpot: false,
      pageSize: 25,
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    backToPrevPage() {
      miscService.goBack();
    },
    onClear() {
      this.term = '';
      this.applyFilters();
    },
    fetch() {
      this.loading = true;
      carrierService
        .getCarrierContracts(this.currentCarrier.carrierId)
        .then((x: CarrierContract[]) => {
          const distinctContracts = x.reduce(
            (acc: CarrierContract[], contract: CarrierContract) => {
              const existingContract = acc.find(
                (c: CarrierContract) => c.accountName === contract.accountName
              );
              if (!existingContract) {
                acc.push(contract);
              }
              return acc;
            },
            []
          );

          this.$store.commit('carrierClients/setContracts', distinctContracts);

          this.applyFilters();
          this.loading = false;
        });
    },
    applyFilters() {
      let items = this.all;

      if (this.term) {
        items = items.filter(
          (x) =>
            x.accountName?.toLowerCase().includes(this.term.toLowerCase()) ||
            x.scac?.toLowerCase().includes(this.term.toLowerCase()) ||
            x.mode?.toLowerCase().includes(this.term.toLowerCase()) ||
            x.contractId
              ?.toString()
              .toLowerCase()
              .includes(this.term.toLowerCase()) ||
            x.contractDescription
              ?.toLowerCase()
              .includes(this.term.toLowerCase()) ||
            x.contractEffDate
              ?.toLowerCase()
              .includes(this.term.toLowerCase()) ||
            x.contractExpDate
              ?.toLowerCase()
              .includes(this.term.toLowerCase()) ||
            x.createdBy?.toLowerCase().includes(this.term.toLowerCase()) ||
            x.uploadedDate?.toLowerCase().includes(this.term.toLowerCase())
        );
      }

      // spot filter
      const spotKeyword = 'spot';
      items = items.filter((x) =>
        this.showSpot
          ? x.contractDescription?.toLowerCase().includes(spotKeyword)
          : !x.contractDescription?.toLowerCase().includes(spotKeyword)
      );

      this.$store.commit('carrierClients/setFilteredContracts', items);
      this.$store.commit(
        'carrierClients/setPage',
        items.slice(0, this.pageSize)
      );
      this.currentPage = 1;
    },
    isActiveContract(val) {
      return moment(this.formatDate(val)).isAfter(moment());
    },
    clearFilters() {
      this.term = '';
      this.applyFilters();
    },
    resetFilter() {
      this.term = '';
      this.applyFilters();
    },
    pageChange(newPage) {
      let page = this.filteredContracts.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
      this.$store.commit('carrierClients/setPage', page);
    },
    showSpotChanged() {
      this.applyFilters();
    },
  },
  computed: {
    ...mapGetters('carrierClients', ['all', 'page', 'filteredContracts']),
    pageHeader() {
      return `${this.currentCarrier?.name}’s Clients`;
    },
    currentCarrier() {
      return localStorageService.get('selected-admin-carrier');
    },
    pagingLength() {
      return Math.ceil(this.filteredContracts.length / this.pageSize);
    },
    backToLbl() {
      return document.referrer?.includes('/dashboard')
        ? 'Back to Dashboard'
        : 'Back to Carriers';
    },
  },
});
